import { useBemCN } from "@gik/core/utils/bemBlock";
import withComponentErrorBoundary from "@gik/core/utils/withComponentErrorBoundary";
import { PageSection } from "@gik/ui-legacy/gik/PageSection";
import React from "react";
import type { IFeatureFocusProps } from "../components/FeatureFocus";
import { FeatureFocus } from "../components/FeatureFocus";

export interface IFeatureFocusSectionProps {
	feature: IFeatureFocusProps;
}

/**
 * https://www.figma.com/design/FT2ninjhNiQOXfnOTaZfqy/%F0%9F%91%A8%F0%9F%8F%BC%E2%80%8D%F0%9F%8E%A4-Jade's-workspace-of-asset-creation?node-id=4696-8722&m=dev
 */
function FeatureFocusSectionComp({ feature }: IFeatureFocusSectionProps) {
	const bem = useBemCN("feature-focus-section");

	return (
		<PageSection
			asElement={"section"}
			largePadding
			{...bem(null, null, "tw-bg-neutral-50 !tw-py-8 !md:tw-py-20")}
		>
			<FeatureFocus {...feature} />
		</PageSection>
	);
}

export const FeatureFocusSection = withComponentErrorBoundary(
	FeatureFocusSectionComp,
);
